import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  shortcutsOverlayItemStyles,
  shortcutsOverlayKeycapStyles,
  shortcutsOverlayLabelStyles,
} from './LoanApplicationPage.styles';

const ShortcutOverlayItem = ({ keycap, label }) => (
  <Box sx={shortcutsOverlayItemStyles}>
    <Typography component="span" sx={shortcutsOverlayKeycapStyles} variant="bold12">
      {keycap}
    </Typography>
    <Typography component="span" sx={shortcutsOverlayLabelStyles} variant="regular12">
      {label}
    </Typography>
  </Box>
);

ShortcutOverlayItem.propTypes = {
  keycap: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default ShortcutOverlayItem;
